import React, { useEffect } from 'react';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInquiryData } from '../../../actions/mgmtRegisterRequest';
import Results from './Result';
import { ClassNames } from '@emotion/react';
import MperitoCard from 'src/components/MperitoCard';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100,
  },
}));

function CustomerRegisterRequest() {
    const classes = useStyles();
  const dispatch = useDispatch();
  const inquiryData = useSelector((state) => state.inquiry.data);

  useEffect(() => {
    dispatch(fetchInquiryData());
  }, [dispatch]);

  const adminList = (inquiryData || []).map((item, index) => ({
    ...item,
    id: item.businessId || index,
  }));
 console.log("Mapped adminList:", adminList); 


return (
    <div>
    <Page
      className={classes.root}
      title="Customer List"
    >
       <Container maxWidth={false}>
         <Header />
                <br />
                <br />
         <MperitoCard title={`Register Request Lists`}>
                    <Results adminList={adminList} />
          </MperitoCard>
     </Container>
    </Page>
    
   
    
    </div>
  );
}

export default CustomerRegisterRequest;
 